import { CustomModal } from '@/components/Shared/Modal/CustomModal';
import { Button, CircledImage } from '@/components/Shared/ui';

export interface LeasingAcceptedOfferInterface {
  auto: string;
  balloonAmount: string;
  initialFee: string;
  leasingCompanyIcon: string;
  leasingCompanyName: string;
  loanAmount: string;
  monthlyPayment: string;
  rate: string;
  term: string;
}

type TLeasingAcceptModalProps = {
  isAcceptLoading: boolean;
  onCancel: () => void;
  onSelectLeasingOffer: () => void;
  selectedOffer: LeasingAcceptedOfferInterface | null;
  showAcceptModal: boolean;
};

const LeasingAcceptModal = ({
  isAcceptLoading,
  onCancel,
  onSelectLeasingOffer,
  selectedOffer,
  showAcceptModal
}: TLeasingAcceptModalProps) => {
  return (
    <CustomModal
      isModalOpen={showAcceptModal}
      title="Предложение выбрано"
      handleCancel={onCancel}
      handleOk={onSelectLeasingOffer}
      editClass="accept-offer-modal"
      footer={[
        <Button key="back" onClick={onCancel}>
          Отмена
        </Button>,
        <Button
          isLoading={isAcceptLoading}
          key="submit"
          variant="filled-red"
          onClick={onSelectLeasingOffer}
        >
          Подтвердить
        </Button>
      ]}
    >
      <div>
        <p className="accept-offer-modal__text">
          Нажимая “Подтвердить” клиент соглашается с условиями лизинговой
          компании
        </p>

        <div className="accept-offer-modal__header">
          <CircledImage
            src={selectedOffer?.leasingCompanyIcon || ''}
            alt={selectedOffer?.leasingCompanyName || ''}
            size={40}
          />
          <div>
            <h6 className="accept-offer-modal__chosen-text">
              Выбрана лизинговая компания
            </h6>
            <h5 className="accept-offer-modal__bank">
              {selectedOffer?.leasingCompanyName || ''}
            </h5>
          </div>
        </div>

        <div className="accept-offer-modal__main-info">
          <div>
            <p className="accept-offer-modal__main-label">Ежемесячный платеж</p>
            <p className="accept-offer-modal__main-value">
              {selectedOffer?.monthlyPayment || ''} ₸
            </p>
          </div>
          <div>
            <p className="accept-offer-modal__main-label">Ставка</p>
            <p className="accept-offer-modal__main-value accept-offer-modal__main-value--red">
              {selectedOffer?.rate || ''} %
            </p>
          </div>
        </div>

        <div className="accept-offer-modal__sub-info">
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">Сумма займа</p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.loanAmount || ''} ₸
            </p>
          </div>
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">Авансовый взнос</p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.initialFee || ''} ₸
            </p>
          </div>
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">
              Остаточная стоимость
            </p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.balloonAmount || ''} ₸
            </p>
          </div>
          <div className="accept-offer-modal__sub-item">
            <p className="accept-offer-modal__sub-label">Срок</p>
            <p className="accept-offer-modal__sub-value">
              {selectedOffer?.term || ''} месяца
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  );
};

export default LeasingAcceptModal;
